<template>
  <sds-page id="header" :title="title" :navigate-back="true">
    <template #header>
      <header
        class="theme--light v-toolbar white d-flex align-center justify-center"
        style="min-height: 125px"
      >
        <div
          class="title font-weight-medium d-flex align-center justify-space-between container px-8"
        >
          <v-row dense class="ma-0 d-flex align-center">
            <div class="mr-4 mt-2">
              <img
                height="110px"
                src="@/assets/images/logo-tjsp.png"
                alt="Logo do tribunal de justiça do estado de São Paulo"
              />
            </div>

            <div
              style="
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                justify-content: center;
              "
            >
              <span class="style-tribunal-title">Tribunal de Justiça</span>
              <span class="style-tribunal-subtitle">Estado de São Paulo</span>
            </div>

            <div class="d-flex align-center ma-3">
              <v-divider vertical style="height: 35px"></v-divider>
            </div>

            <span class="ma-0 font-weight-medium">{{ title }}</span>
          </v-row>
          <v-btn outlined :href="VUE_APP_URL_ACESSIBILIDADE" target="_blank">
            Acessibilidade
            <v-icon class="ml-1">
              {{ mdiHuman }}
            </v-icon>
          </v-btn>
        </div>
      </header>
    </template>
    <slot> </slot>
  </sds-page>
</template>

<script setup lang="ts">
import { mdiHuman } from '@mdi/js';

defineProps<{ title: string }>();

const { VUE_APP_URL_ACESSIBILIDADE } = process.env;
</script>
<style lang="scss" scoped>
.style-tribunal-title {
  font-weight: bold;
  color: #f44336;
  font-size: 24px;
  font-family: 'Open Sans';
}
.style-tribunal-subtitle {
  margin: 0;
  color: #727272;
  font-size: 16px;
  font-family: 'Open Sans';
}

.container {
  max-width: 74.75rem;
}
</style>
